import { Button, Card, InputGroup } from '@blueprintjs/core';
import AppContentView from 'Components/Generic/AppContentView';
import AppData from 'Data/AppData';
import SiteDialogData from 'Data/SiteDialogData';
import withRouter from 'Lib/hoc/withRouter';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

const DevLoginPage = ({ location }) => {
  const [devUserName, setDevUserName] = useState('u0351456');
  const [, setResponders] = useState([]);

  useEffect(() => {
    let responderArray = [];
    responderArray.push(
      AppData.registerListener('LOGIN_ERROR', loginErrorHandler),
    );
    setResponders(responderArray);
  }, []);

  const loginClicked = () => {
    const { from } = location.state || {};
    const { pathname, search } = from || {};

    window.location = `auth/login/dev?username=${devUserName}&pathname=${
      pathname ?? '/'
    }&search=${search ?? ''}`;
  };

  const loginErrorHandler = (err) => {
    let reason = err?.debug || 'Unknown';
    SiteDialogData.open('Login Error', reason);
  };

  const onKeyPress = (e) => {
    if (e.which === 13) {
      loginClicked();
    }
  };

  return (
    <AppContentView hideBreadcrumbs title='Developer Log In'>
      <Card style={{ width: 400 }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <InputGroup
            fill
            type='text'
            onChange={(e) => setDevUserName(e.target.value)}
            defaultValue={devUserName}
            autoFocus
            onKeyDown={onKeyPress}
          />
          <Button onClick={loginClicked}>Login</Button>
        </div>
      </Card>
    </AppContentView>
  );
};

DevLoginPage.propTypes = {
  location: PropTypes.object,
};

let Page = withRouter(DevLoginPage);
export default Page;
